import styled from 'styled-components';
import { BannerBackgroundImgDiv, BannerBackgroundImg } from '../shared/BannerBackgroundImgDiv';
import { makeExternalUrl } from '../../../../lib/utils';
import SymbolFormat from '../shared/SymbolFormat';

const HeroBannerBackgroundImgDiv = styled(BannerBackgroundImgDiv)`
  max-width: none;
  width: 100%;
`;

const HeroBannerBackgroundImg = styled(BannerBackgroundImg)`
  max-width: none;
  width: 100%;
  position: absolute;
  object-fit: cover;
`;

const CenteredColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 0 16px;
`;

const TextOverlayH1 = styled.h1`
  ${({ theme }) => theme.typographyRebrand.heading['3xl']}
  text-transform: uppercase;
  z-index: ${p => p.theme.elevation[0]};
  color: ${p => (p.fontColor ? p.fontColor : p.theme.c.text.invert)};
  margin: 0 ${p => (p.isMobile ? p.theme.unit(1) : p.theme.unit(3))};
  text-align: center;
  margin-bottom: ${p => p.theme.unit(2)};
`;

const HeroSubtextDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.heading['xl']}
  z-index: ${p => p.theme.elevation[0]};
  color: ${p => (p.fontColor ? p.fontColor : p.theme.c.text.invert)};
  text-align: center;
`;

const SeasonalHeroBanner = (props) => {
  const {
    seasonalPageData = {},
    isMobile = false,
  } = props;

  const {
    heroImageUrl = '',
    heroText = '',
    heroFontColor = '',
    heroSubtext = '',
  } = seasonalPageData;

  const externalHeroImageUrl = makeExternalUrl(heroImageUrl);

  return (
    <HeroBannerBackgroundImgDiv>
      <HeroBannerBackgroundImg src={externalHeroImageUrl} alt="" />
      <CenteredColumnDiv>
        <TextOverlayH1 isMobile={isMobile} fontColor={heroFontColor} >
          <SymbolFormat text={heroText} />
        </TextOverlayH1>
        <HeroSubtextDiv isMobile={isMobile} fontColor={heroFontColor}>
          <SymbolFormat text={heroSubtext} />
        </HeroSubtextDiv>
      </CenteredColumnDiv>
    </HeroBannerBackgroundImgDiv>
  );
};

export default SeasonalHeroBanner;
